import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["cssFn", "href"];
import React, { forwardRef } from 'react';
import { LinkItem as Link } from '@atlaskit/menu';
import { baseSideNavItemStyle, overrideStyleFunction } from '../../common/styles';
import { useShouldNestedElementRender } from '../NestableNavigationContent/context';
/**
 * __Link item__
 *
 * Renders an item wrapped in an anchor tag, useful when you have an item that
 * should change routes using native browser navigation. For SPA transitions use
 * a [custom item](https://atlassian.design/components/side-navigation/examples#custom-item)
 * with the respective router logic.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#link-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */
var LinkItem = /*#__PURE__*/forwardRef(
// Type needed on props to extract types with extract react types.
function (_ref, ref) {
  var cssFn = _ref.cssFn,
    href = _ref.href,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useShouldNestedEleme = useShouldNestedElementRender(),
    shouldRender = _useShouldNestedEleme.shouldRender;
  if (!shouldRender) {
    return null;
  }
  var cssOverride = overrideStyleFunction(baseSideNavItemStyle, cssFn);

  // Anchor content will be handled by LinkItem
  // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @repo/internal/react/no-unsafe-overrides, jsx-a11y/anchor-has-content
  return /*#__PURE__*/React.createElement(Link, _extends({
    ref: ref,
    cssFn: cssOverride,
    href: href
  }, rest));
});
export default LinkItem;